import React, { useCallback, useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {
  Card,
  Chip,
  SwipeableDrawer,
  TextareaAutosize,
  Tooltip,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EditIcon from "@mui/icons-material/Edit";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Handle, Position } from "reactflow";
import { HandleDot } from "../handle";
import InputLabel from "@mui/material/InputLabel";
import Divider from "@mui/material/Divider";
import AddBoxIcon from "@mui/icons-material/AddBox";
import TextField from "@mui/material/TextField";
import { useTheme } from "../../../contexts/ThemeContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";

export const TextNodeEditModal = ({ open, handleClose, data }) => {
  const isEditMode = !!data?.id;
  const { darkMode } = useTheme();
  const [text, setText] = useState(isEditMode ? data.data?.label : "");

  const onAdd = () => {
    handleClose(text, isEditMode);
  };
  const onClose = () => {
    handleClose();
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: darkMode ? "#121212" : "background.paper",
    border: `1px solid ${darkMode ? "#2f2f2f" : "#cecece"}`,
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      background: {
        default: darkMode ? "#121212" : "#ffffff",
        paper: darkMode ? "#121212" : "#ffffff",
      },
      text: {
        primary: darkMode ? "#fafafa" : "#000000",
        secondary: darkMode ? "#fafafa" : "#666666",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          contained: {
            backgroundColor: darkMode ? "#0086ff" : "#1976d2",
            "&:hover": {
              backgroundColor: darkMode ? "#0077ff" : "#1565c0",
            },
          },
          outlined: {
            borderColor: darkMode ? "#2f2f2f" : "#1976d2",
            color: darkMode ? "#fafafa" : "#1976d2",
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: darkMode ? "#2f2f2f" : "#cecece",
              },
              "&:hover fieldset": {
                borderColor: darkMode ? "#404040" : "#b0b0b0",
              },
              "&.Mui-focused fieldset": {
                borderColor: darkMode ? "#0086ff" : "#0086ff",
              },
            },
            "& .MuiInputLabel-root": {
              color: darkMode ? "#fafafa" : "#666666",
            },
            "& .MuiInputBase-input": {
              color: darkMode ? "#fafafa" : "#000000",
            },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Modal open={open} onClose={onClose}>
        <Box sx={style}>
          <div className={`${darkMode ? "text-gray-100" : "text-gray-900"}`}>
            Enter some text for User
          </div>
          <div className="m-2"></div>
          <TextareaAutosize
            className="p-2"
            value={text}
            onChange={(e) => setText(e.target.value)}
            style={{
              border: `1px solid ${darkMode ? "#2f2f2f" : "#cecece"}`,
              borderRadius: 4,
              width: 300,
              backgroundColor: darkMode ? "#121212" : "#ffffff",
              color: darkMode ? "#fafafa" : "#000000",
            }}
          />
          <div className="m-2"></div>
          <Button variant="contained" onClick={onAdd} disabled={!text.length}>
            {isEditMode ? "Update" : "Add"}
          </Button>
          <Button
            style={{ marginLeft: 12 }}
            variant="outlined"
            onClick={onClose}
          >
            Close
          </Button>
        </Box>
      </Modal>
    </ThemeProvider>
  );
};

export const TextNode = (props) => {
  const {
    data,
    selected,
    onEdit,
    onAdd,
    isAddVisible,
    onTrigger,
    triggerData = [],
    onInboundTrigger,
    inboundTriggerData,
    ...rest
  } = props;

  const { darkMode } = useTheme();
  const [contactFormData, setContactFormData] = useState([]);
  const [open, setOpen] = useState(false);

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  const fetchData2 = useCallback(() => {
    let myHeaders = new Headers();
    const name = "auth_token";
    let authtoken = getCookie(name);
    authtoken = "Token " + authtoken;
    myHeaders.append("Authorization", authtoken);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      "https://api-test.phloz.app/contacts/Contactform",
      requestOptions
    )
      .then((res) => res.json())
      .then((data) => {
        setContactFormData(data.data);
      });
  }, []);

  useEffect(() => {
    fetchData2();
  }, [fetchData2]);

  const onCloseModal = (result) => {
    if (result) {
      onTrigger(result.trigger);
      if (onInboundTrigger) {
        onInboundTrigger(result.inboundTrigger);
      }
    }
    setOpen(false);
  };

  return (
    <div
      className={`w-40 shadow-md rounded-lg ${
        darkMode
          ? "bg-[#1e1e1e] border border-[#333333]"
          : "bg-white border-gray-200"
      } ${
        selected
          ? `border-solid border-2 ${
              darkMode ? "border-indigo-400" : "border-indigo-500/100"
            }`
          : ""
      } `}
    >
      <div className="flex flex-col">
        <div className="max-h-max px-2 py-1 text-left text-black text-xs font-bold rounded-t-md bg-teal-300">
          {props.id === "1" ? "Incoming Message Trigger" : "Text"}
          <Tooltip title={rest.id}>
            <ErrorOutlineIcon style={{ fontSize: 10 }} />
          </Tooltip>
          {props.id !== "1" && (
            <Tooltip className="ml-2" title="Edit">
              <EditIcon style={{ fontSize: 12 }} onClick={() => onEdit(props)} />
            </Tooltip>
          )}
        </div>
        {props.id === "1" && (
          <div style={{ margin: 24 }}>
            <Button
              variant="contained"
              style={{
                fontSize: 10,
                padding: 6,
                backgroundColor: "#0086ff",
                color: "#ffffff",
              }}
              onClick={() => {
                setOpen(!open);
              }}
            >
              {triggerData?.length ||
              inboundTriggerData?.adIds?.length ||
              inboundTriggerData?.value
                ? "Configure Trigger"
                : "Set Trigger"}
            </Button>
            {inboundTriggerData?.value && (
              <div
                style={{
                  fontSize: 9,
                  marginTop: 8,
                  color: darkMode ? "#fafafa" : "#374151",
                  wordBreak: "break-word",
                }}
              >
                {inboundTriggerData.operator === "CONTAINS"
                  ? "Contains"
                  : "Exactly matches"}
                : “{inboundTriggerData.value}”
              </div>
            )}
          </div>
        )}
        {props.id !== "1" && (
          <div
            style={{
              fontSize: 10,
              padding: 6,
              color: darkMode ? "#fafafa" : "inherit",
            }}
          >
            {data?.label}
          </div>
        )}
      </div>

      {props.id !== "1" && (
        <Handle id="b" type="target" position={Position.Left} />
      )}
      <HandleDot
        addVisible={true}
        id="b"
        type="source"
        position={Position.Right}
        onAdd={(v) => onAdd(v, rest)}
      />
      {open && (
        <Drawer
          data={contactFormData}
          open={true}
          onClose={onCloseModal}
          triggerData={triggerData}
          inboundTriggerData={inboundTriggerData}
        />
      )}
    </div>
  );
};

export const Drawer = ({
  open,
  data,
  onClose,
  triggerData,
  inboundTriggerData,
}) => {
  const { darkMode } = useTheme();
  const [options, setOptions] = useState([]);
  const [mainData, setMainData] = useState(triggerData);
  const [count, setCount] = useState(1);
  const [adIds, setAdIds] = useState(inboundTriggerData?.adIds || []);
  const [adIdInput, setAdIdInput] = useState("");
  const [messageOperator, setMessageOperator] = useState(
    inboundTriggerData?.operator || "EXACT"
  );
  const [messageValue, setMessageValue] = useState(
    ["MESSAGE_MATCH", "INCOMING_MESSAGE_MATCH"].includes(
      inboundTriggerData?.type
    )
      ? inboundTriggerData?.value || ""
      : ""
  );

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      background: {
        default: darkMode ? "#121212" : "#ffffff",
        paper: darkMode ? "#121212" : "#ffffff",
      },
      text: {
        primary: darkMode ? "#fafafa" : "#000000",
        secondary: darkMode ? "#fafafa" : "#666666",
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          contained: {
            backgroundColor: darkMode ? "#0086ff" : "#1976d2",
            "&:hover": {
              backgroundColor: darkMode ? "#0077ff" : "#1565c0",
            },
            color: "#ffffff",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: darkMode ? "#121212" : "#ffffff",
            border: darkMode ? "1px solid #2f2f2f" : "none",
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            backgroundColor: darkMode ? "#2f2f2f" : "rgba(0, 0, 0, 0.12)",
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: darkMode ? "#2f2f2f" : "rgba(0, 0, 0, 0.23)",
              borderWidth: "1px",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: darkMode ? "#404040" : "rgba(0, 0, 0, 0.87)",
            },
            "&.Mui-focused": {
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },

              boxShadow: `0 0 0 1px ${darkMode ? "#0086ff" : "#1976d2"}`,
            },
            color: darkMode ? "#fafafa" : "inherit",
            "&:focus": {
              outline: "none",
            },
            borderRadius: "4px",
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            "&:hover": {
              backgroundColor: darkMode ? "#2f2f2f" : "rgba(0, 0, 0, 0.04)",
            },
            "&.Mui-selected": {
              backgroundColor: darkMode
                ? "#333333"
                : "rgba(25, 118, 210, 0.08)",
              "&:hover": {
                backgroundColor: darkMode
                  ? "#404040"
                  : "rgba(25, 118, 210, 0.12)",
              },
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: darkMode ? "#fafafa" : "rgba(0, 0, 0, 0.6)",
            "&.Mui-focused": {
              color: darkMode ? "#0086ff" : "#1976d2",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: darkMode ? "#2f2f2f" : "rgba(0, 0, 0, 0.23)",
              },
              "&:hover fieldset": {
                borderColor: darkMode ? "#404040" : "rgba(0, 0, 0, 0.87)",
              },
              "&.Mui-focused fieldset": {
                borderColor: darkMode ? "#0086ff" : "#1976d2",
              },
            },
            "& .MuiInputBase-input": {
              color: darkMode ? "#fafafa" : "inherit",
            },
          },
        },
      },
    },
  });

  useEffect(() => {
    setTimeout(() => {
      setCount(2);
    }, 500);
  }, []);

  useEffect(() => {
    if (count === 2) {
      let allItems = [];
      data.forEach((i) => {
        allItems = allItems.concat(i.fields);
      });
      setMainData((currentMainData) =>
        currentMainData.length
          ? currentMainData.map((items) =>
              items.map((i) => {
                if (i.type === "SINGLECHOICE") {
                  let item = allItems.find((j) => j.id === i.id);
                  if (item) {
                    return {
                      ...i,
                      options: (item.list || []).map((k) => ({
                        value: k.id,
                        label: k.label,
                      })),
                    };
                  }
                }
                return i;
              })
            )
          : currentMainData
      );
    }
  }, [count, data]);

  useEffect(() => {
    let _options = [];
    if (data.length) {
      (data || []).forEach((d) => {
        (d.fields || []).forEach((field) => {
          _options.push({ value: field.id, label: field.label });
        });
      });
    }
    setOptions(_options);
  }, [data]);

  const onFieldChange = (val, pIndex, cIndex) => {
    let allItems = [];
    data.forEach((i) => {
      allItems = allItems.concat(i.fields);
    });
    let _mainData = [...mainData];
    _mainData[pIndex][cIndex].id = val;
    _mainData[pIndex][cIndex].options = val;
    let item = allItems.find((j) => j.id === val);
    if (item) {
      _mainData[pIndex][cIndex].type = item.fieldType;
      _mainData[pIndex][cIndex].options = (item.list || []).map((k) => ({
        value: k.id,
        label: k.label,
      }));
    }
    _mainData[pIndex][cIndex].value = {
      id: "",
    };
    setMainData(_mainData);
  };

  const onValueChange = (val, pIndex, cIndex) => {
    let _mainData = [...mainData];
    if (_mainData[pIndex][cIndex].type === "TEXT") {
      if (_mainData[pIndex][cIndex].value) {
        _mainData[pIndex][cIndex].value.value = val;
      } else {
        _mainData[pIndex][cIndex].value = { value: val };
      }
    } else {
      _mainData[pIndex][cIndex].value.id = val;
    }
    setMainData(_mainData);
  };

  const onPlusClick = (pIndex) => {
    let _mainData = [...mainData];
    _mainData[pIndex] = [
      ..._mainData[pIndex],
      {
        id: null,
        type: "SINGLECHOICE",
        value: {
          id: null,
        },
      },
    ];
    setMainData(_mainData);
  };

  const onAddCondition = () => {
    setMainData([
      ...mainData,
      [
        {
          id: null,
          type: "",
          value: {
            id: null,
          },
        },
      ],
    ]);
  };

  const onAddAdId = () => {
    const newIds = adIdInput
      .split(",")
      .map((i) => i.trim())
      .filter((i) => i.length && !adIds.includes(i));
    if (newIds.length) {
      setAdIds([...adIds, ...newIds]);
    }
    setAdIdInput("");
  };

  const onRemoveAdId = (id) => {
    setAdIds(adIds.filter((i) => i !== id));
  };

  const onSave = () => {
    const pending = adIdInput
      .split(",")
      .map((i) => i.trim())
      .filter((i) => i.length && !adIds.includes(i));
    const savedAdIds = [...adIds, ...pending];
    const savedMessage = messageValue.trim();
    const inboundTrigger = savedMessage
      ? {
          type: "MESSAGE_MATCH",
          operator: messageOperator,
          value: savedMessage,
          caseSensitive: false,
          ...(savedAdIds.length ? { adIds: savedAdIds } : {}),
        }
      : savedAdIds.length
      ? { type: "AD_REFERRAL", adIds: savedAdIds }
      : {};
    onClose({ trigger: mainData, inboundTrigger });
  };

  return (
    <ThemeProvider theme={theme}>
      <SwipeableDrawer
        anchor={"right"}
        open={open}
        onClose={() => {
          onClose(null);
        }}
        onOpen={() => {}}
        sx={{
          "& .MuiDrawer-paper": {
            backgroundColor: darkMode ? "#121212" : "#ffffff",
          },
        }}
      >
        <div
          style={{
            marginBottom: 12,
            marginTop: 12,
            marginLeft: 36,
            fontSize: 18,
            minWidth: 300,
            color: darkMode ? "#fafafa" : "inherit",
          }}
        >
          <b>Events</b>
        </div>
        <div style={{ margin: 36 }}>
          {(mainData || []).map((ii, index) => {
            return (
              <Card style={{ padding: 16, marginBottom: 16 }} key={index}>
                {ii.map((i, cIndex) => {
                  return (
                    <div key={cIndex}>
                      <div>
                        <InputLabel
                          id={`field-label-${index}-${cIndex}`}
                          style={{ color: darkMode ? "#fafafa" : "inherit" }}
                        >
                          Select Field
                        </InputLabel>
                        <Select
                          labelId={`field-label-${index}-${cIndex}`}
                          value={i.id || ""}
                          onChange={(e) => {
                            onFieldChange(e.target.value, index, cIndex);
                          }}
                          style={{ width: 300, height: 35, marginBottom: 12 }}
                          label="Select"
                          placeholder={"Select"}
                        >
                          {options.map((field) => (
                            <MenuItem key={field.value} value={field.value}>
                              {field.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      {i.type === "SINGLECHOICE" && (
                        <div>
                          <InputLabel
                            id={`value-label-${index}-${cIndex}`}
                            style={{ color: darkMode ? "#fafafa" : "inherit" }}
                          >
                            Select Value
                          </InputLabel>
                          <Select
                            value={i.value.id || ""}
                            onChange={(e) => {
                              onValueChange(e.target.value, index, cIndex);
                            }}
                            style={{ width: 300, height: 35, marginBottom: 12 }}
                            label="Select Event"
                          >
                            {(i?.options || []).map((option) => {
                              return (
                                <MenuItem
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </div>
                      )}
                      {i.type === "TEXT" && (
                        <div>
                          <InputLabel
                            id={`text-label-${index}-${cIndex}`}
                            style={{ color: darkMode ? "#fafafa" : "inherit" }}
                          >
                            Select Value
                          </InputLabel>
                          <TextField
                            value={i.value?.value || ""}
                            onChange={(e) => {
                              onValueChange(e.target.value, index, cIndex);
                            }}
                            className="mt-2"
                            label="Input Value"
                            style={{ width: 300, height: 25, marginBottom: 12 }}
                            variant="outlined"
                          />
                        </div>
                      )}
                      {cIndex + 1 !== ii.length && (
                        <Divider style={{ margin: 12 }} />
                      )}
                      {cIndex + 1 === ii.length && (
                        <div className="mt-8 text-center cursor-pointer">
                          <AddBoxIcon
                            onClick={(e) => onPlusClick(index)}
                            style={{ color: darkMode ? "#fafafa" : "inherit" }}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </Card>
            );
          })}
          {
            <div className="text-center cursor-pointer">
              <Button
                variant="contained"
                onClick={(e) => onAddCondition()}
                startIcon={<AddBoxIcon />}
              >
                Add condition
              </Button>
            </div>
          }
          <Divider style={{ marginTop: 24, marginBottom: 24 }} />
          <div
            style={{
              fontSize: 14,
              marginBottom: 4,
              color: darkMode ? "#fafafa" : "inherit",
            }}
          >
            <b>Incoming message match</b>
          </div>
          <div
            style={{
              fontSize: 11,
              marginBottom: 12,
              color: darkMode ? "#a0a0a0" : "#666666",
            }}
          >
            Start this workflow when a customer sends a matching text message.
            Matching is case-insensitive.
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Select
              value={messageOperator}
              onChange={(e) => setMessageOperator(e.target.value)}
              size="small"
              style={{ width: 105, height: 40 }}
            >
              <MenuItem value="EXACT">Equals</MenuItem>
              <MenuItem value="CONTAINS">Contains</MenuItem>
            </Select>
            <TextField
              value={messageValue}
              onChange={(e) => setMessageValue(e.target.value)}
              label="Customer message"
              placeholder="Class 10 Educart PDF by PK Bhaiya"
              size="small"
              style={{ width: 260 }}
              variant="outlined"
            />
          </div>
          <Divider style={{ marginTop: 24, marginBottom: 24 }} />
          <div
            style={{
              fontSize: 14,
              marginBottom: 4,
              color: darkMode ? "#fafafa" : "inherit",
            }}
          >
            <b>Inbound message from Ad (Click-to-WhatsApp)</b>
          </div>
          <div
            style={{
              fontSize: 11,
              marginBottom: 12,
              color: darkMode ? "#a0a0a0" : "#666666",
            }}
          >
            Trigger this flow when a contact messages you from one of these
            ads.
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextField
              value={adIdInput}
              onChange={(e) => setAdIdInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  onAddAdId();
                }
              }}
              label="Ad ID"
              placeholder="e.g. 120211234567890123"
              size="small"
              style={{ width: 220 }}
              variant="outlined"
            />
            <Button
              variant="contained"
              style={{ marginLeft: 8 }}
              disabled={!adIdInput.trim().length}
              onClick={onAddAdId}
            >
              Add
            </Button>
          </div>
          <div style={{ marginTop: 12, maxWidth: 300 }}>
            {adIds.map((id) => (
              <Chip
                key={id}
                label={id}
                onDelete={() => onRemoveAdId(id)}
                style={{
                  margin: 4,
                  color: darkMode ? "#fafafa" : "inherit",
                  backgroundColor: darkMode ? "#2f2f2f" : undefined,
                }}
              />
            ))}
          </div>
        </div>
        <>
          <Divider style={{ margin: 12 }} />
          <div className="flex justify-center">
            {(!!mainData?.[0]?.[0]?.id ||
              !!messageValue.trim() ||
              adIds.length > 0 ||
              ["MESSAGE_MATCH", "INCOMING_MESSAGE_MATCH"].includes(
                inboundTriggerData?.type
              ) ||
              (inboundTriggerData?.adIds?.length || 0) > 0) && (
              <Button
                variant="contained"
                onClick={() => {
                  onSave();
                }}
              >
                Save
              </Button>
            )}
            <Button
              variant="contained"
              style={{
                marginLeft: 12,
                backgroundColor: darkMode ? "#6b7280" : "#9e9e9e",
              }}
              onClick={() => {
                onClose(null);
              }}
            >
              Close
            </Button>
          </div>
        </>
      </SwipeableDrawer>
    </ThemeProvider>
  );
};
